

const Home = () => {
  

  return (
    
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="pageName">
              <h4>Home</h4>
            </div>
          </div>
        </div>
      </div>
     
    
  );
};

export default Home;
